// extracted by mini-css-extract-plugin
module.exports = {"coinCollectorItem":"Leaderboard_coinCollectorItem__1Aehf","root":"Leaderboard_root__3uJjC","paper":"Leaderboard_paper__1ss3Z"};